import { TeamMember } from '@betterfunnel/types';
import { collection, orderBy, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../Firebase';
import { emptyConverter } from '../utils';

export const teamMembersColRef = (accountId: string) => {
  return collection(db, 'accounts', accountId, 'team').withConverter(
    emptyConverter<TeamMember>(),
  );
};

export const approvedTeamMembersQuery = (accountId: string) => {
  return query(
    teamMembersColRef(accountId),
    where('status', 'in', ['approved']),
    orderBy('createdAt', 'asc'),
  );
};

export const addMember = async (
  accountId: string,
  email: string,
  name: string,
  role: 'member' | 'admin',
  features?: string[],
) => {
  const fn = httpsCallable(functions, 'accounts-team-addMember');
  const res = await fn({
    accountId,
    invites: [{ email, name, role, features: features || [] }],
  });

  return res.data;
};

export const updateMember = async (
  accountId: string,
  memberId: string,
  name: string,
  role: string,
  features?: string[],
) => {
  const fn = httpsCallable(functions, 'accounts-team-updateMember');
  const res = await fn({
    accountId,
    memberId,
    name,
    role,
    ...(features ? { features } : {}),
  });

  return res.data;
};

export const removeMember = async (accountId: string, memberId: string) => {
  const fn = httpsCallable(functions, 'accounts-team-removeMember');
  const res = await fn({ accountId, memberId });

  return res.data;
};
